import { render } from "./RequestCardList.vue?vue&type=template&id=3b2ab526&scoped=true&ts=true"
import script from "./RequestCardList.vue?vue&type=script&lang=ts"
export * from "./RequestCardList.vue?vue&type=script&lang=ts"

import "./RequestCardList.vue?vue&type=style&index=0&id=3b2ab526&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2ab526"]])

export default __exports__